angular.module("vgresiduos").factory("accountService", [
	"$rootScope",
	"rootScopeService",
	"localStorageService",
	"$q",
	"$http",
	"$state",
	"permissionService",
	"httpService",
	"awsCognitoService",
	"featureToggleService",
	"translationService",
	"organizationService",
	function (
		$rootScope,
		rootScopeService,
		localStorageService,
		$q,
		$http,
		$state,
		permissionService,
		httpService,
		awsCognitoService,
		featureToggleService,
		translationService,
		organizationService
	) {
		"use strict";

		let _refreshingVgrSession = false;

		function _isLoggedInIdp() {
			return awsCognitoService.isLoggedIn();
		}

		function _loginWithTokenRequest() {
			const req = {
				method: "post",
				url: Vgr.constants.coreHostUrl + "v1/login"
			};
			return $http(req);
		}

		function _validateIdentityProvider(idp) {
			const req = {
				method: "post",
				data: { identityProvider: idp },
				url: Vgr.constants.coreHostUrl + "v1/organizations/identity-provider/validate"
			};
			return $http(req);
		}

		const _getLoggedUserAccountInfo = function () {
			const req = {
				method: "get",
				url: Vgr.constants.coreHostUrl + Vgr.resources.core.accountInfo
			};
			return $http(req);
		};

		const _updateAccountInfo = function (dto) {
			const req = {
				method: "put",
				data: dto,
				url: Vgr.constants.coreHostUrl + Vgr.resources.core.accountInfo
			};
			return $http(req);
		};

		const _setUserLanguage = function (language) {
			const req = {
				method: "put",
				data: { Language: language },
				url: Vgr.constants.coreHostUrl + Vgr.resources.core.accountInfo + "language"
			};
			return $http(req);
		};

		function _loginWithFederatedIdentity(customIdp) {
			localStorageService.set(Vgr.constants.authentication.previousLoggedSsoIdp, customIdp);

			awsCognitoService.initiateCustomIdpLogin(customIdp);
		}

		function _loginWithUsernameAndPassword(username, password) {
			localStorageService.set(Vgr.constants.authentication.previousLoggedSsoIdp, null);

			const promise = awsCognitoService.initiateVgrLogin(username, password);
			promise.then(function (user) {
				if (user && user.challengeName == Vgr.constants.authentication.challenge.newPasswordRequired) {
					loginState = Vgr.enumerations.loginState.loggedNewPasswordRequired;
				}
			});

			return promise;
		}

		function _isRefreshingVgrSession() {
			return _refreshingVgrSession;
		}

		function _refreshVgrSession() {
			if (_refreshingVgrSession) {
				const deferred = $q.defer();
				deferred.reject();
				return deferred.promise;
			}

			_refreshingVgrSession = true;
			const promise = awsCognitoService.refreshSession();
			promise.then(
				function (tokens) {
					$rootScope.$broadcast(Vgr.constants.evtVgrLoginSuccess, tokens);
					_refreshingVgrSession = false;
				},
				function (err) {
					$rootScope.$broadcast(Vgr.constants.evtVgrLoginFailure, err);
					_refreshingVgrSession = false;
				}
			);
			return promise;
		}

		function _changeTemporaryPassword(password, idpRequiredAttributes) {
			return awsCognitoService.completeNewPassword(password, idpRequiredAttributes);
		}

		const _getLoginOptions = function (username) {
			const req = {
				method: "post",
				url: Vgr.constants.coreHostUrl + Vgr.resources.core.accounts + username + "/login-options"
			};

			return $http(req);
		};

		const _forgotPassword = function (username) {
			const req = {
				method: "post",
				url: Vgr.constants.coreHostUrl + Vgr.resources.core.accounts + username + "/forgot-password"
			};

			return $http(req);
		};

		function _resendCode(username) {
			const req = {
				method: "post",
				url: Vgr.constants.coreHostUrl + Vgr.resources.core.accounts + username + "/verification"
			};
			return $http(req);
		}

		const _confirmForgotPassword = function (model) {
			const req = {
				method: "put",
				data: model,
				url: Vgr.constants.coreHostUrl + Vgr.resources.core.accounts + model.username + "/forgot-password"
			};

			return $http(req);
		};

		function _getCachedVgrToken() {
			return awsCognitoService.getCachedTokens();
		}

		function _getTokenRefreshingIfNecessary() {
			const deferred = $q.defer();
			const tokens = _getCachedVgrToken();
			if (tokens) {
				deferred.resolve(tokens);
			} else {
				_refreshVgrSession().then(() => {
					deferred.resolve(_getCachedVgrToken());
				});
			}
			return deferred.promise;
		}

		function _setAppLogin() {
			localStorageService.set(Vgr.constants.authentication.appLogin, true);
		}

		function _getAppLogin() {
			return localStorageService.get(Vgr.constants.authentication.appLogin);
		}

		function _loginWithToken() {
			const deferred = $q.defer();

			loginState = Vgr.enumerations.loginState.loggingIn;

			httpService.getDTOFromServiceV2(_loginWithTokenRequest, "", true).then(
				function (loginWithTokenResponse) {
					localStorageService.set(Vgr.constants.authentication.account, loginWithTokenResponse.account);

					permissionService.setUserPermission(loginWithTokenResponse.permissions);

					translationService.setLanguage(_getLoggedAccount().language);

					$rootScope.$broadcast(Vgr.constants.evtChangeLoginStatus, true);

					loginState = Vgr.enumerations.loginState.logged;
					deferred.resolve(loginWithTokenResponse);
				},
				function (error) {
					loginState = Vgr.enumerations.loginState.loginError;
					deferred.reject(error);
				}
			);

			return deferred.promise;
		}

		const _getLoggedAccount = function () {
			return localStorageService.get(Vgr.constants.authentication.account);
		};

		const _reloadLoggedAccount = function () {
			httpService.getDTOFromServiceV2(_getLoggedUserAccountInfo).then(
				function (account) {
					localStorageService.set(Vgr.constants.authentication.account, account);

					if (account.forceLogout) {
						_logout();
						window.location.reload(true);
					} else {
						$rootScope.$broadcast(Vgr.constants.evtChangeLoggedUserInfo);
					}
				},
				function () {
					_logout();
					window.location.reload(true);
				}
			);
		};

		const _getIdentityProviderCurrentChallengeParams = function () {
			return awsCognitoService.getCurrentChallengeParams();
		};

		const _getCurrentClient = function () {
			return localStorageService.get(Vgr.constants.authentication.client);
		};

		const _isMasterClient = function () {
			const clientData = _getCurrentClient();
			if (clientData) {
				return clientData.id == Vgr.constants.VGclientID;
			}
			return false;
		};

		function _changeClientRequest(request) {
			const req = {
				method: "put",
				data: request,
				url: Vgr.constants.coreHostUrl + Vgr.resources.core.accountInfo + "last-organization-unit"
			};
			return $http(req);
		}

		const _changeClient = function (organizationId, organizationUnitId, ignoreErrorMessageHandling) {
			const deferred = $q.defer();

			_cleanPreferences();
			const request = {
				organizationId,
				organizationUnitId
			};
			httpService.postDTOToServiceV2(_changeClientRequest, request, ignoreErrorMessageHandling).then(
				function (response) {
					const organizationUnit = Vgr.dtoMappings.organizationUnit.fromCoreToContext(response);
					localStorageService.set(Vgr.constants.authentication.client, organizationUnit);
					featureToggleService
						.loadFeatureToggles(organizationUnit.organization.id, organizationUnit.id, _getLoggedAccount().code)
						.then(
							function () {
								$rootScope.$broadcast(Vgr.constants.evtChangeLoggedClient);
								deferred.resolve();
							},
							function () {
								deferred.reject();
							}
						);
				},
				function () {
					deferred.reject();
				}
			);

			return deferred.promise;
		};

		const _reloadCurrentClient = function () {
			const deferred = $q.defer();

			const currentOrganizationUnit = _getCurrentClient();
			if (!currentOrganizationUnit) {
				deferred.reject();
				return deferred.promise;
			}
			httpService
				.getDTOFromServiceV2(
					organizationService.getOrganizationUnit,
					{
						organizationId: currentOrganizationUnit.organization.id,
						organizationUnitCode: currentOrganizationUnit.code
					},
					true
				)
				.then(
					function (response) {
						const organizationUnit = Vgr.dtoMappings.organizationUnit.fromCoreToContext(response);
						localStorageService.set(Vgr.constants.authentication.client, organizationUnit);
						$rootScope.$broadcast(Vgr.constants.evtChangeLoggedClientInfo);
						deferred.resolve(organizationUnit);
					},
					function (error) {
						deferred.reject(error);
					}
				);

			return deferred.promise;
		};

		function _cleanPreferences() {
			rootScopeService.setDisposalPreferences(null);
			rootScopeService.setStoragePreferences(null);
			rootScopeService.setStockControlPreferences(null);
		}

		const _goHome = function GoHome(reload) {
			if (reload) {
				$state.go("home", null, {
					reload: true
				});
			} else {
				$state.go("home");
			}
		};

		function getLoginParams(username, idp, error) {
			const params = {};
			if (username) {
				params.username = username;
			}
			if (idp) {
				params.idp = idp;
			}
			if (error) {
				params.error = error;
			}
			return params;
		}

		const _getPreviousLoggedSsoIdp = function () {
			return localStorageService.get(Vgr.constants.authentication.previousLoggedSsoIdp);
		};

		const _goToLogin = function (username, error) {
			if (username) {
				$state.go("login", getLoginParams(username));
			} else {
				const idp = _getPreviousLoggedSsoIdp();
				if (idp) {
					$state.go("chooseLogin", getLoginParams(null, idp, error));
				} else {
					$state.go("login", getLoginParams(null, null, error));
				}
			}
		};

		const _isLoggedIn = function () {
			return _getLoggedAccount() ? true : false;
		};

		const _logoutConditional = function () {
			const deferred = $q.defer();

			const isMasterLoggedInAnotherClient = permissionService.isMaster() && !_isMasterClient();

			if (!isMasterLoggedInAnotherClient) {
				_logout();
				deferred.resolve(true);
			} else {
				_changeClient(Vgr.constants.VGclientID, Vgr.constants.VGclientID).then(
					function () {
						deferred.resolve(false);
					},
					function () {
						_logout();
						deferred.resolve(true);
					}
				);
			}

			return deferred.promise;
		};

		const _logout = function () {
			loginState = Vgr.enumerations.loginState.loggingOut;
			awsCognitoService.logout();
			_removeLoginData();
			_removeEntitiesCache();

			$rootScope.$broadcast(Vgr.constants.evtChangeLoginStatus, false);
		};

		function _removeLoginData() {
			localStorageService.remove(Vgr.constants.authentication.account);
			localStorageService.remove(Vgr.constants.authentication.client);
			localStorageService.remove(Vgr.constants.authentication.permissions);
			localStorageService.remove(Vgr.constants.authentication.featureToggle);
		}

		function _removeEntitiesCache() {
			const keys = localStorageService.keys();
			removeKeysStartingWithPrefixFromCache(keys, Vgr.constants.cacheKeysPrefix.measureUnits);
			removeKeysStartingWithPrefixFromCache(keys, Vgr.constants.cacheKeysPrefix.scales);
			removeKeysStartingWithPrefixFromCache(keys, Vgr.constants.cacheKeysPrefix.disposalPendencyTypes);
			removeKeysStartingWithPrefixFromCache(keys, Vgr.constants.cacheKeysPrefix.disposalTypes);
		}

		function removeKeysStartingWithPrefixFromCache(keys, prefix) {
			const cacheKeys = keys.filter(function (k) {
				return k.indexOf(prefix) >= 0;
			});
			for (const key of cacheKeys) {
				localStorageService.remove(key);
			}
		}

		let loginState = Vgr.enumerations.loginState.notLogged;
		const _isLogoutInProgress = function () {
			return loginState == Vgr.enumerations.loginState.loggingOut;
		};

		const _isLoginOnIdpInProgress = function () {
			return loginState == Vgr.enumerations.loginState.loggingInOnIdp;
		};

		function _setLoggingIn() {
			loginState = Vgr.enumerations.loginState.loggingIn;
		}

		return {
			getLoggedAccount: _getLoggedAccount,
			getCurrentClient: _getCurrentClient,
			loginWithToken: _loginWithToken,
			isLoggedInIdp: _isLoggedInIdp,
			setLoggingIn: _setLoggingIn,
			isLoggedIn: _isLoggedIn,
			logout: _logout,
			logoutConditional: _logoutConditional,
			validateIdentityProvider: _validateIdentityProvider,
			reloadLoggedAccount: _reloadLoggedAccount,
			reloadCurrentClient: _reloadCurrentClient,

			getLoginOptions: _getLoginOptions,
			forgotPassword: _forgotPassword,
			confirmForgotPassword: _confirmForgotPassword,
			resendCode: _resendCode,

			changeTemporaryPassword: _changeTemporaryPassword,

			loginWithUsernameAndPassword: _loginWithUsernameAndPassword,
			loginWithFederatedIdentity: _loginWithFederatedIdentity,
			refreshVgrSession: _refreshVgrSession,
			isRefreshingVgrSession: _isRefreshingVgrSession,
			getCachedVgrToken: _getCachedVgrToken,
			getTokenRefreshingIfNecessary: _getTokenRefreshingIfNecessary,
			setAppLogin: _setAppLogin,
			getAppLogin: _getAppLogin,

			changeClient: _changeClient,
			goHome: _goHome,
			goToLogin: _goToLogin,
			getPreviousLoggedSsoIdp: _getPreviousLoggedSsoIdp,
			isLogoutInProgress: _isLogoutInProgress,
			isLoginOnIdpInProgress: _isLoginOnIdpInProgress,

			updateAccountInfo: _updateAccountInfo,
			setUserLanguage: _setUserLanguage,

			getIdentityProviderCurrentChallengeParams: _getIdentityProviderCurrentChallengeParams,

			removeEntitiesCache: _removeEntitiesCache
		};
	}
]);
